const databaseMenuOptions = [
  {
    label: "Products",
    path: "/data",
  },
  {
    label: "Exhibit",
    path: "/data/exhibit",
  },
  {
    label: "Guest House",
    path: "/data/guest-house",
  },
];

const categoryTypes = {
  drink: [
    "beer",
    "energy drinks",
    "soft drinks",
    "cocktails",
    "vodka",
    "rum",
    "tequila",
    "champagne",
    "red wine",
    "non alcoholic wine",
    "cream liquor",
    "spirits",
    "aperitif",
    "whiskey",
    "cognac",
    "water",
  ],
  food: [
    "peppersoups",
    "meals",
    "peppered meat",
    "shawarma",
    "grill",
    "amala hut",
    "takeaway",
  ],
};

export { databaseMenuOptions, categoryTypes };
